import React, { Component } from 'react';
import { isEmpty } from 'lodash';
import Alert from 'components/ui/Alert';
import PhoneField from 'components/v2/forms/PhoneField';
import { Translation, withTranslation } from 'react-i18next';
import CargomaticInput from 'components/v2/input';
import FormCard from '../../v2/FormCard';
import UserActionCreators from '../../../actions/UserActionCreators';
import SessionStore from '../../../stores/SessionStore';
import { CARRIER_SUBSIDIARY_OPTIONS } from 'constants/subsidiary';
const getEmptyState = () => {
    return {
        carrier: {
            company_name: '',
            email: '',
            dot_number: '',
            first_name: '',
            last_name: '',
            password: '',
            phone: '',
            subsidiary: '',
        },
        isCustomerManager: SessionStore.isCustomerManagerAdmin(),
    };
};
class RegisterCarrier extends Component {
    constructor(props) {
        super(props);
        this.handlePhoneChange = (phone) => {
            this.setState((prevState) => {
                return {
                    carrier: Object.assign(Object.assign({}, prevState.carrier), { phone }),
                };
            });
        };
        this.handleChange = (field) => (e) => {
            const { target: { value }, } = e;
            this.setState((prevState) => {
                return {
                    carrier: Object.assign(Object.assign({}, prevState.carrier), { [field]: value }),
                };
            });
        };
        this.handleCargomaticInputChange = (field, value) => {
            this.setState((prevState) => {
                return {
                    carrier: Object.assign(Object.assign({}, prevState.carrier), { [field]: value }),
                };
            });
        };
        this.handleRegister = (e) => {
            e.preventDefault();
            const { carrier } = this.state;
            UserActionCreators.addCarrier(Object.assign({}, carrier));
            this.setState(getEmptyState());
        };
        this.state = getEmptyState();
    }
    render() {
        const { carrier, isCustomerManager } = this.state;
        const { t } = this.props;
        const disabled = isEmpty(carrier.company_name) ||
            isEmpty(carrier.dot_number) ||
            isEmpty(carrier.email) ||
            isEmpty(carrier.first_name) ||
            isEmpty(carrier.last_name) ||
            isEmpty(carrier.password) ||
            isEmpty(carrier.phone) ||
            !isCustomerManager;
        return (React.createElement(FormCard, { actions: () => (React.createElement("button", { disabled: disabled, className: "button button-green", type: "submit", onClick: this.handleRegister }, t('REGISTER_CARRIER'))) },
            !isCustomerManager && (React.createElement(Alert, { type: "warning" },
                React.createElement(Translation, null, (t) => React.createElement("p", null, t('REQUIRED_CUSTOMER_MANAGER_PRIVILEGES'))))),
            React.createElement("div", { className: "mb-4" },
                React.createElement("h3", { className: "text-lg font-medium text-gray-900 leading-6" }, t('CARRIER_PROFILE'))),
            React.createElement("div", { className: "grid grid-cols-4 gap-6" },
                React.createElement("div", { className: "col-span-4 sm:col-span-2" },
                    React.createElement("label", { className: "block mb-2 form-label" }, t('FIRST_NAME')),
                    React.createElement("input", { className: "w-full mb-4 form-field", type: "text", placeholder: "John", onChange: this.handleChange('first_name'), value: carrier.first_name, disabled: !isCustomerManager })),
                React.createElement("div", { className: "col-span-4 sm:col-span-2" },
                    React.createElement("label", { className: "block mb-2 form-label" }, t('LAST_NAME')),
                    React.createElement("input", { className: "w-full mb-4 form-field", type: "text", placeholder: "Smith", onChange: this.handleChange('last_name'), value: carrier.last_name, disabled: !isCustomerManager })),
                React.createElement("div", { className: "col-span-4 sm:col-span-2" },
                    React.createElement("label", { className: "block mb-2 form-label" },
                        React.createElement("span", null, t('COMPANY_NAME'))),
                    React.createElement("input", { className: "w-full mb-4 form-field", type: "text", placeholder: t('COMPANY_NAME'), onChange: this.handleChange('company_name'), value: carrier.company_name, disabled: !isCustomerManager })),
                React.createElement("div", { className: "col-span-4 sm:col-span-2" },
                    React.createElement(CargomaticInput, { className: "block mb-2 form-label", inputClassNames: "w-full mb-4 form-field", label: t('DOT_NUMBER'), type: "text", placeholder: t('DOT_NUMBER'), onChange: (value) => {
                            this.handleCargomaticInputChange('dot_number', value);
                        }, value: carrier.dot_number, disabled: !isCustomerManager })),
                React.createElement("div", { className: "col-span-4 sm:col-span-2" },
                    React.createElement("label", { className: "block mb-2 form-label" }, t('PHONE')),
                    React.createElement(PhoneField, { value: carrier.phone, onChange: this.handlePhoneChange, disabled: !isCustomerManager })),
                React.createElement("div", { className: "col-span-4 sm:col-span-2" },
                    React.createElement(CargomaticInput, { className: "block mb-2 form-label", inputClassNames: "w-full mb-4 form-field", type: "text", label: t('PHONE_EXTENSION'), placeholder: t('PHONE_EXTENSION'), onChange: (value) => {
                            this.handleCargomaticInputChange('phone_extension', value);
                        }, value: carrier.phone_extension, disabled: !isCustomerManager })),
                React.createElement("div", { className: "col-span-4 sm:col-span-2" },
                    React.createElement("label", { className: "block mb-2 form-label" }, t('EMAIL')),
                    React.createElement("input", { className: "w-full mb-4 form-field", type: "email", placeholder: "example@cargomatic.com", onChange: this.handleChange('email'), value: carrier.email, disabled: !isCustomerManager })),
                React.createElement("div", { className: "col-span-4 sm:col-span-2" },
                    React.createElement("label", { className: "block mb-2 form-label" }, t('PASSWORD')),
                    React.createElement("input", { className: "w-full mb-4 form-field", type: "password", placeholder: t('PASSWORD'), onChange: this.handleChange('password'), value: carrier.password, disabled: !isCustomerManager })),
                React.createElement("div", { className: "col-span-4 sm:col-span-2" },
                    React.createElement("label", { className: "block mb-2 form-label" },
                        React.createElement("span", null, t('SUBSIDIARY'))),
                    React.createElement("select", { className: "mb-4 form-select", onChange: this.handleChange('subsidiary'), value: carrier.subsidiary || '', disabled: !isCustomerManager },
                        React.createElement("option", { value: "" }, t('SELECT_SUBSIDIARY')),
                        CARRIER_SUBSIDIARY_OPTIONS.map((subsidiary) => (React.createElement("option", { key: subsidiary.key, value: subsidiary.value }, t(subsidiary.localizationSlug)))))))));
    }
}
export default withTranslation()(RegisterCarrier);
